import { Modal, Form, Select, Radio, Button, DatePicker } from "antd";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./index.module.css";
import { UpdateLoanStatus } from "Management/components/UpdateLoanStatus";
import { dateSuffixIcon } from "LoanSummary/components/Notice/Step/options";
import dayjs from "dayjs";
import { UpdateLoanOverviewData,UpdateApplicationAttribute } from "Store/actions";
import { CurrentStatus, CurrentStatusUtils } from "Common";
import { UR_Owner } from "State";
import { checkAccess } from "Auth";
import NewModal from "Common/NewModal";
import {getDispositionUpdateForm} from '../../UpdateLoanStatus';
// TODO-List触发的
const UpdateModal = ({ onCancel, loanId ,open=true}) => {
  const [form] = Form.useForm();
  const loanRef = useRef();
  const updateType = Form.useWatch("updateType", form);
  const currentStage = Form.useWatch("currentStage", form);
  const currentStatus = Form.useWatch("currentStatus", form);
  const dispatch = useDispatch();

  // 更改状态
  const handleCurrentChange = (Value, Key = "currentStage") => {
    let token = sessionStorage.getItem("ZeitroA");
    let body = {
      LoanID: loanId,
      Key,
      Value,
      IsAdmin: checkAccess([UR_Owner]) ? true : false,
    };
    fetch("/los/updatepipeline", {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        Authorization: "Bearer " + token,
        Cache: "no-cache",
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          console.log(
            "Looks like there was a problem. Status Code: " + response.status
          );
          return;
        }
        dispatch(UpdateApplicationAttribute(Value, Key));
      })
      .catch(function (err) {
        console.log("Fetch Error :-S", err);
      });
  };

  const onFinish = async () => {
    const values = await form.validateFields();
    if (updateType) {
      loanRef?.current && loanRef.current.changeRedux(values);
      values.currentStage && handleCurrentChange(values.currentStage, "currentStage");
      //延迟因为一个页面出现多个状态选择时，让其最后生效
      setTimeout(()=>{
        values.currentStatus && handleCurrentChange(values.currentStatus, "currentStatus");
      },500)
    } else {
      const v = values?.expirationDate
        ? dayjs(values.expirationDate).format("MM/DD/YYYY")
        : "";
      v && await dispatch(
        UpdateLoanOverviewData(v, "preApprovalLetterExpirationDate")
      );
    }
    onCancel();
  };

  // 预填充数据
  const getInitRow = async() =>{
    if(!loanId) return;
    const row = await getDispositionUpdateForm(loanId);
    form.setFieldsValue({...row,expirationDate:row.preApprovalLetterExpirationDate})
  }
  const disposedOp = Object.entries(CurrentStatus).filter(
    ([_,value]) => value < 500 && value >= 400
  ).map(([value])=>({label:<div>{CurrentStatusUtils.getStatusName(value)}</div>,value,key:value}));
  
  const closingOp = [{label:'Loan Funded',value:"LoanFunded"}];
  const options = useMemo(() => {
    return  currentStage === "Disposed" ? disposedOp : closingOp;
  }, [currentStage, currentStatus]);

  useEffect(()=>{
      getInitRow();
  },[])

  const updateLoanStatus = (
    <div className={styles.radioBox}>
      <span className={styles.radioBoxLabel}>Update loan status</span>
      {updateType && (
        <div
          className={styles.updateStatusSelect}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          {/* <StageStatusForm
            currentStage={rowData.currentStage}
            currentStatus={rowData.currentStatus}
            loanID={rowData.loanID}
            isOpenUpdateModal={false}
          /> */}
          <Form.Item name="currentStage">
            <Select
              style={{ width: 104, height: 33 }}
              options={[
                { value: "Closing", label: "Closing" },
                { value: "Disposed", label: "Disposed" },
              ]}
              className={styles.key}
              size="small"
              onChange={(e) => {
                form.setFieldsValue({
                  currentStatus: e === "Closing" ? closingOp[0]?.value : disposedOp[0]?.value,
                });
              }}
              suffixIcon={
                <img src="/images/stepper-menu-arrow-down.svg" alt="down-arrow" />
              }
            />
          </Form.Item>
          <Form.Item name="currentStatus">
            <Select
              style={{ width: 235, height: 33 }}
              options={options}
              className={[
                styles.value,
                currentStage === "Disposed" && styles.value_widthdrawn,
                currentStage === "Closing" && styles.value_loanfunded,
              ].join(" ")}
              size="small"
              onChange={()=>{
                if (!currentStage) {
                  form.setFieldsValue({currentStatus:''})
                }
              }}
              disabled={!currentStage}
              suffixIcon={
                <img src="/images/stepper-menu-arrow-down.svg" alt="down-arrow" />
              }
              placeholder="Choose from list"
            />
          </Form.Item>
        </div>
      )}
      {currentStage === "Closing" && currentStatus === "LoanFunded" && (
        <UpdateLoanStatus
          isNoForm={false}
          isDispatchRedux={false}
          ref={loanRef}
          rowProps={{gutter:12,className:styles.loanStatusRow}}
        />
      )}
    </div>
  );

  const preApprovalLetter = (
    <div className={styles.radioBox}>
      <span className={styles.radioBoxLabel}>
        I have an active Pre-Approval letter
      </span>
      {updateType === false && (
        <div className={styles.preApprovalLetter}>
          <Form.Item name="expirationDate" label="Expiration date" className={styles.expirationDate}>
            <DatePicker
              size="large"
              format="MM/DD/YYYY"
              suffixIcon={dateSuffixIcon}
            />
          </Form.Item>
        </div>
      )}
    </div>
  );

  return (
    <NewModal
      title="Disposition update"
      open={open}
      footer={null}
      width={566}
      onCancel={onCancel}
      className={styles.updateModal}
      getContainer={()=>document.getElementById('portal-root')}
      onOk={onFinish}
    >
      <div className={styles.updateScroll}>

        <div className={styles.tips}>
          This loan application has been inactive for 60 days after submission
          date. Please take one of the following actions to proceed:
        </div>
        <Form
          name="updateForm"
          onFinish={onFinish}
          form={form}
          className={styles.updateForm}
        >
          <Form.Item
            name="updateType"
            rules={[{ required: true, message: "please choose" }]}
          >
            <Radio.Group
              className={styles.radioGroup}
              options={[
                { value: true, label: updateLoanStatus },
                { value: false, label: preApprovalLetter },
              ]}
            />
          </Form.Item>
        </Form>
      </div>
      {/* <div className={styles.footerBtn}>
        <Button type="link" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="primary" onClick={onFinish}>
          Save
        </Button>
      </div> */}
    </NewModal>
  );
};
export default UpdateModal;
